/**
 * @architecture-header 1
 * @layer module-data
 * @domain settings-subscription
 * @responsibility Versioned static SET-F08 plan-matrix copy -- every organization is
 *   unconditionally Free (owner ruling); higher tiers are illustrative and contact-gated, never a
 *   real payment commitment.
 * @state-owner none -- static data, not fetched
 * @allowed-imports none
 * @forbidden any computed or backend-sourced price; a plan reachable without contacting Vispo
 * @public-api SUBSCRIPTION_PLANS
 * @side-effects none
 * @tests SubscriptionSettingsSurface.test.tsx
 */

export interface SubscriptionPlan {
  comingSoon: boolean;
  current: boolean;
  features: readonly string[];
  id: string;
  name: string;
  price: string;
}

export const SUBSCRIPTION_PLANS: readonly SubscriptionPlan[] = [
  {
    comingSoon: false,
    current: true,
    features: ['基本課程與活動功能', '無限學生人數', 'Email 支援'],
    id: 'free',
    name: 'Free',
    price: 'NT$0 / 教師 / 月',
  },
  {
    comingSoon: true,
    current: false,
    features: ['進階報表', '優先支援', '企業級安全性功能'],
    id: 'pro',
    name: 'Pro',
    price: '即將公布 / 教師 / 月',
  },
];
